/**
 * API clients of the admin app. Sign-in uses the normal auth endpoints (/api/v1/auth);
 * everything else is the staff API (/admin/v1). The CSRF token is kept in memory only.
 */
import { createApiClient, unwrap as unwrapCall, type ApiError } from "@esp/api-client";
import { createAdminClient } from "@esp/api-client/admin";

let csrfToken: string | null = null;
const unauthorizedListeners = new Set<(error: ApiError) => void>();

export const session = {
  setCsrfToken(token: string | null) {
    csrfToken = token;
  },
  onUnauthorized(listener: (error: ApiError) => void): () => void {
    unauthorizedListeners.add(listener);
    return () => {
      unauthorizedListeners.delete(listener);
    };
  },
};

const context = {
  csrfToken: () => csrfToken,
  organizationId: () => null,
  onUnauthorized: (error: ApiError) => unauthorizedListeners.forEach((listener) => listener(error)),
};

export const auth = createApiClient(context);
export const admin = createAdminClient(context);

export function unwrap<T>(call: Promise<{ data?: T; error?: unknown; response: Response }>): Promise<T> {
  return unwrapCall(call, context);
}
